<div class="c-multi-select">
  <label v-if="label" :for="updatedLabel" class="txt-ellipsis bold">
    {{ updatedLabel && $t(updatedLabel) }}
    <span v-if="required" class="txt-danger txt-required">
      <span>*</span>
    </span>
  </label>

  <div @click="onSelect" v-outside="outsideClick" @keydown="handleKeyDown" @keydown.stop tabindex="0" :class="{'active' : isDropdown, 'outline-danger': isError, 'select-box-disabled' : readonly}" class="row c-select">
    <div class="c-option">
      <div class="select-valued">
        <span v-if="selectedValue.length" v-for="option in selectedValue" class="mr5 selected-value">{{ option[optionLabel] }} <span @click.stop @click="deleteOptionValue(option)" class="ml5">&#x2715;</span></span>
        <span v-else class="font15">{{ !placeholder?$t('componentSelect'):'' }} {{ updatedLabel && $t(updatedLabel) }}</span>
      </div>
      <i
        :class="isDropdown ? 'icon-element-up':'icon-element-down', {'mr0' : readonly && selectedValue.length}"
        class="fa-angle-down fa bold ic-arrow-down"
      ></i>
      <!-- <i
        :class="isDropdown ? 'icon-element-up':'icon-element-down', {'mr22' : readonly && selectedValue.length}"
        class="fa-angle-down fa bold ic-arrow-down"
      ></i> -->
      <!-- <button
        v-if="readonly && selectedValue.length"
        @click.stop
        @click="copyToClipboard"
        :tooltip="showPopup ? $t('componentCopied') : $t('componentCopy')"
        class="btn btn-danger btn-xs clone-icon tooltip mr3"
        style="right: 19px;top: 0px;height: 100%;"
      >
        <i class="fa fa-clone"></i>
      </button> -->
    </div>
    <div v-if="isDropdown" :class="[isTop ? 'bottom-dropdown' : 'top-dropdown']" class="c-select-dropdown c-select-dropdown-active" @click.stop>
      <div class="c-select-dropdown-item">
        <input v-if="searchable && !isTop" @input="onFilter" v-model="keySearch" :ref='"keySearchQuery"' @click.stop :placeholder="$t('componentSearch')" type="text" class="input mb10 c-search-input">
        <div v-if="!isTop" @click.stop class="row mt10 mb10">
          <label :class="'txt-info bold font15 cursor'">
            <input type="checkbox" :checked="isCreateSelect" @change="toggleCreateSelect" class="input-checkbox">
            {{ $t("componentSelectMore") }}
          </label>
        </div>
        <div class="row c-select-option-list">
          <li @click="onSelectValue(item)" v-for="item in optionList" :key="item" @click.stop :class="{'active' : findActiveOption(item[optionLabel])}" class="font15">
            {{ item[optionLabel] }}
          </li>
  
          <div v-if="!optionList.length" @click.stop class="no-select-data">{{ $t('componentEmptyData') }}</div>
        </div>
        <div v-if="isTop" @click.stop class="row mt10">
          <label :class="'txt-info bold font15 cursor'">
            <input type="checkbox" :checked="isCreateSelect" @change="toggleCreateSelect" class="input-checkbox">
            {{ $t("componentSelectMore") }}
          </label>
        </div>
        <input v-if="searchable && isTop" @input="onFilter" v-model="keySearch" :ref='"keySearchQuery"' @click.stop :placeholder="$t('componentSearch')" type="text" class="input mt10 c-search-input">
      </div>
    </div>
  </div>

  <p v-if="isError && showError" class="mb0 txt-danger font14 mt3">
    <span>{{ $t(isError) }}</span>
  </p>
</div>
